import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase config is loaded from environment variables so that
// the same codebase can point at different Firebase projects
// (test vs prod) without any code changes.
//
// The active env file is determined at build time:
//   npm run deploy:test  →  uses .env.test
//   npm run deploy:prod  →  uses .env.prod
//   npm start            →  uses .env.local (set this to test)
//
// Never hardcode credentials here. Put them in the .env files.
const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services.
//
// Storage is deliberately NOT initialized here. Every page imports this module,
// so calling getStorage() at module scope pulled the whole Storage SDK into the
// main bundle for visitors who never upload anything. Nothing imported the
// export anyway — AdminPage imports getStorage from 'firebase/storage' directly
// and calls it itself, which keeps the SDK in the lazily-loaded admin chunk.
// Don't re-add it here.
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
